import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { message, Input, Modal } from "antd";

import { createMessage, updateMessageStatuses } from "../../graphql/mutations";

import { PrimaryButton, WhiteButton } from "../../components/button";
import Spacer from "../../components/spacer/spacer";

import images from "../../assets";

const { TextArea } = Input;

export default function MessageSendButton(props) {
  const navigate = useNavigate();
  const profileData = useSelector((state) => state?.profile?.profile);

  const [msgText, setMsgText] = useState("");
  const [open, setOpen] = useState(false);

  const createSingleMessage = async () => {
    try {
      const trimmedMsgText = msgText.trim();
      if (trimmedMsgText === "") {
        return;
      }

      setMsgText("");
      await props?.client.graphql({
        query: createMessage,
        variables: {
          input: {
            content: {
              sender: profileData?.username,
              text: trimmedMsgText,
            },
            roomId: props?.activeUser?.id,
          },
        },
        headers: {
          "x-api-key": props?.apiKey,
        },
      });
    } catch (e) {
      if (
        e.errors[0].message === "Please upgrade your plan to send messages."
      ) {
        setOpen(true);
      } else {
        message.error(e.errors[0].message);
      }
      console.error("in create message error", e);
    }
  };

  const updateMessageStatus = async () => {
    if (
      props.lastMsgObj &&
      props.lastMsgObj?.content?.sender !== profileData?.username
    ) {
      try {
        await props?.client.graphql({
          query: updateMessageStatuses,
          variables: {
            input: {
              roomId: props?.lastMsgObj?.roomId,
              username: profileData?.username,
            },
          },
          headers: {
            "x-api-key": props?.apiKey,
          },
        });
      } catch (e) {
        console.error("in message status update room error", e);
      }
    }
  };

  const EnterPress = (e) => {
    if (msgText !== "") {
      if (e.keyCode === 13 && e.shiftKey === false) {
        e.preventDefault();
        createSingleMessage();
      }
    }
  };

  return (
    <div className="premium-message-submit">
      <div className="premium-message-submit-box">
        <TextArea
          className="premium-message-inputtext"
          style={{
            width: "100%",
            outline: "none",
            background: "transparent",
            border: "none",
            paddingLeft: "0px",
          }}
          rows="2"
          placeholder="Type your message here ..."
          onKeyDown={EnterPress}
          variant="borderless"
          onChange={(e) => setMsgText(e.target.value)}
          value={msgText}
          onFocus={() => {
            updateMessageStatus();
          }}
        />
        <div className="submit-btn-icon shadow" onClick={createSingleMessage}>
          <img src={images.submitBtnIcon} alt="Send Message" />
        </div>
      </div>
      <Modal
        centered={true}
        open={open}
        onCancel={() => setOpen(false)}
        footer={false}
        closable={false}
      >
        <div className="gap-4 set-profile-photo-content">
          <div className="set-profile-photo-icon">
            <img style={{ maxWidth: "40px" }} src={images?.deleteIcon} alt="" />
          </div>
          <div className="set-profile-photo-heading">
            <p className="!text-black">
              Message is not delivered.
              <br />
              <br />
              <strong>Upgrade</strong> to get full access. After upgrading, you
              can enjoy unlimited chat.
            </p>
          </div>
        </div>
        <Spacer height="16px" />
        <div className="flex w-full justify-end">
          <div className="flex gap-4 set-profile-photo-btn">
            <WhiteButton
              style={{
                width: "120px",
                border: "2px solid #EAE6ED",
              }}
              text={"Skip"}
              onClick={() => setOpen(false)}
            />
            <PrimaryButton
              style={{
                width: "157px",
              }}
              text={"Upgrade"}
              onClick={() => navigate("/membership-plan")}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
}
